<template>
    <div style="display: flex; flex-direction: column;">
        <div class="display-6">产品编码</div>

        <div style="display: flex; flex-direction: row;">

            <div @click="menuclick" style="margin-top: 20px; display: flex;flex-direction: column;">
                <div class="wrap" style="width: 330px; border: solid #CCC 1px;transition: all 1s ease;">
                    <img src="Motor.png" style="width: 100%;height: 200px;padding: 0 0 0 20px;" alt="">
                    <div style="height: 20px; background-color: #CCC; ">电机</div>
                </div>
            </div>

            <div style="margin-top: 20px; margin-left: 20px; display: flex;flex-direction: column;">
                <div class="wrap" style="width: 330px; border: solid #CCC 1px;transition: all 1s ease;">
                    <img src="Screen.png" style="width: 100%;height: 200px;padding: 0 0 0 20px;" alt="">
                    <div style="height: 20px; background-color: #CCC; ">仪表</div>
                </div>
            </div>

            <div style="margin-top: 20px; margin-left: 20px; display: flex;flex-direction: column;">
                <div class="wrap" style="width: 330px; border: solid #CCC 1px;transition: all 1s ease;">
                    <img src="MotorSet.png" style="width: 100%;height: 200px;padding: 0 0 0 20px;" alt="">
                    <div style="height: 20px; background-color: #CCC; ">马达座</div>
                </div>
            </div>

            <div style="margin-top: 20px; margin-left: 20px; display: flex;flex-direction: column;">
                <div class="wrap" style="width: 330px; border: solid #CCC 1px;transition: all 1s ease;">
                    <img src="Chainwheel.png" style="width: 100%;height: 200px;padding: 0 0 0 20px;" alt="">
                    <div style="height: 20px; background-color: #CCC; ">牙盘</div>
                </div>
            </div>

        </div>

        <el-dialog >

        </el-dialog>

    </div>
</template>

<script>
export default {
    data() {
        return {
            title: '牙盘'
        }
    },
    methods:{
        menuclick(){
            window.alert('dsafsdaf');
        }
    }

}
</script>

<style scoped>
.wrap:hover {
    background-color: #EEE;
}
</style>